import svgLogo from "../assets/images/landing/logo.svg";
import svgNaverblog from "../assets/images/landing/naverblog.svg";
import { logout } from "../api/auth";
import { SessionStorageUtil } from "../utils/session_storage_util";

import "../assets/css/app_landing_v2.scss";

function Footer() {
  const isLoggedIn = !!SessionStorageUtil.getItem("accessToken");

  const handleLogout = async () => {
    await logout();
    window.location.href = "/login";
  };

  return (
    <div className="section-footer footer-light">
      <div className="section-content">
        {/* 상단: CTA */}
        <div className="footer-cta">
          <p className="footer-cta-sub scroll-reveal">지금 바로 시작하세요</p>
          <h2 className="footer-cta-title scroll-reveal">
            아이의 성장을 위한
            <br />
            첫 걸음, 키즈다
          </h2>
          <div className="footer-cta-buttons scroll-reveal">
            <a
              href="https://apps.apple.com/kr/app/키즈다/id6738370393"
              target="_blank"
              rel="noreferrer"
              className="btn-store btn-store-white"
            >
              <i className="fab fa-apple"></i>
              <span>App Store</span>
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.aslo.smartview.donga.kids"
              target="_blank"
              rel="noreferrer"
              className="btn-store btn-store-white"
            >
              <i className="fab fa-google-play"></i>
              <span>Google Play</span>
            </a>
          </div>
        </div>

        {/* 중단: 회사 정보 + 링크 */}
        <div className="footer-mid">
          <div className="footer-info">
            <div className="footer-logo">
              <img
                src={svgLogo}
                alt="키즈다"
                className="logo-svg logo-svg-white"
              />
            </div>
            <div className="footer-details">
              <p>
                법인명: <strong>(주)위고컴퍼니</strong> | 제호:{" "}
                <strong>키즈다</strong>
              </p>
              <p>
                주소: 서울특별시 서초구 바우뫼로 162, 우광빌딩 4F
                <br />
                대표전화: 02-3288-3455 | 팩스: 02-3288-3454
              </p>
              <p>발행인: 김영기 | 편집인: 김준영 | 청소년보호책임자: 김준영</p>
              <p>
                등록번호: 경기 아 54914
                <br />
                등록일: 2026-07-22 | 최초발행일: 2026-08-18
              </p>
            </div>
          </div>

          <div className="footer-links-group">
            <div className="footer-col">
              <a href="/">키즈다 뉴스</a>
              <a href="/intro">서비스 소개</a>
              <a href="/news">키즈다 소식</a>
              <a href="/product">구독</a>
              {/* 에듀클립 메뉴 숨김 처리
              <a href="/educlip">에듀클립</a>
              */}
            </div>
            <div className="footer-col">
              <a href="/application/service" target="_blank" rel="noreferrer">
                이용약관
              </a>
              <a href="/application/privacy" target="_blank" rel="noreferrer">
                개인정보처리방침
              </a>
              {isLoggedIn && (
                <button onClick={handleLogout} className="footer-logout-btn">
                  로그아웃
                </button>
              )}
            </div>
          </div>
        </div>

        {/* 하단: 저작권 */}
        <div className="footer-bottom">
          <p className="copyright">
            &copy; 2026 Kidsda Inc. All rights reserved.
          </p>
          <div className="social-links">
            <a
              href="https://www.instagram.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="https://www.youtube.com"
              target="_blank"
              rel="noreferrer"
              aria-label="YouTube"
            >
              <i className="fab fa-youtube"></i>
            </a>
            <a
              href="https://www.facebook.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href="https://blog.naver.com"
              target="_blank"
              rel="noreferrer"
              className="blog-icon"
              aria-label="네이버 블로그"
            >
              <img src={svgNaverblog} alt="네이버 블로그" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
